::ng-deep particle-arrangement-chart-organization-name-cell-editor{display:flex;width:100%}::ng-deep particle-arrangement-chart-organization-name-cell-editor form{width:100%}
/*# sourceMappingURL=arrangement-chart-organization-name-cell-editor.component-HMIGQ5ZB.css.map */
